export function differenceTimeIntervalInSeconds(
  startTime: string,
  endTime: string
) {
  const startDate = new Date(`2023-01-01T${normalizeTimeDigits(startTime)}`);
  const endDate = new Date(`2023-01-01T${normalizeTimeDigits(endTime)}`);

  const timeDifference = endDate.getTime() - startDate.getTime();
  let timeWith24HourDifference = timeDifference;

  if (timeDifference < 0) {
    timeWith24HourDifference = timeDifference + 24 * 1000 * 60 * 60;
  }

  return timeWith24HourDifference / 1000;
}

function normalizeTimeDigits(time: string) {
  return time
    .split(':')
    .map((el) => el.padStart(2, '0'))
    .join(':');
}
